!function (e) {
  "use strict";

  function o(e) {
    return window.btoa([].slice.call(new Uint8Array(e)).map(function (e) {
      return String.fromCharCode(e);
    }).join(""));
  }
  function u(e) {
    return e.toString("base64");
  }
  function s(e) {
    return /(\.(jpg)|\.(png)|\.(jpeg))/gi.test(e) ? Promise.resolve((n = e, t = require("fs"), r = require("path"), t.statSync(n).isFile() ? u(t.readFileSync(r.resolve(n)).toString("base64")) : null)) : Promise.reject("[*] Occurent some error... [validTypeImage] == false");
    var n, t, r;
  }
  function n(e, n) {
    return "undefined" != typeof window && "document" in window && "navigator" in window ? (r = e, i = n, "fetch" in window && "Promise" in window ? fetch(r, i || {}).then(function (e) {
      return e.arrayBuffer();
    }).then(o) : Promise.reject("[*] It's image2base64 not compatible with your browser.")) : /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/gi.test(t = e) ? require("node-fetch")(t).then(function (e) {
      return e.buffer();
    }).then(u) : s(t);
    var t, r, i;
  }
  "undefined" != typeof module ? module.exports = n : e.imageToBase64 = n;
}(this);